import { render } from "./QimenWealthAndBusiness.vue?vue&type=template&id=091a1420&scoped=true"
import script from "./QimenWealthAndBusiness.vue?vue&type=script&lang=js"
export * from "./QimenWealthAndBusiness.vue?vue&type=script&lang=js"

import "./QimenWealthAndBusiness.vue?vue&type=style&index=0&id=091a1420&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091a1420"]])

export default __exports__